<div id="dialog-container" class="fx-layout-col" cdkTrapFocus>
  <h1 mat-dialog-title>{{ 'TITLE.ADD_EXISTING_ASSETS' | translate }}</h1>

  <mat-divider></mat-divider>

  <mat-dialog-content class="fx-layout-col">
    <form novalidate class="fx-flex-initial">
      <div class="fx-layout-row fx-justify-end fx-align-center">

        <mat-form-field class="filter-input mat-mdc-form-field-appearance-standard m-r-10">
          <button mat-icon-button matPrefix [disableRipple]="true" aria-label="Search"
                  class="no-hover">
            <i class="mdi mdi-magnify"></i>
          </button>

          <input matInput type="text" class="filter-text-box" name="nameSearch"
                 (click)="onClickSearchBox()"
                 [formControl]="nameSearchControl"
                 [placeholder]="'PLACEHOLDER.SEARCH' | translate"/>

          @if (!!nameSearchControl.value) {
            <button mat-icon-button matIconSuffix aria-label="Clear" [disableRipple]="true"
                    class="no-hover"
                    (click)="nameSearchControl.setValue(null)">
              <i class="mdi mdi-close-circle"></i>
            </button>
          }
        </mat-form-field>
      </div>

    </form>

    <div class="datagrid-container">
      <ag-grid-angular (gridReady)="onGridReady($event)"
                       [gridOptions]="gridOptions"
                       class="ag-theme-material clickable-rows"
                       id="asset-grid">
      </ag-grid-angular>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="center">
    <button mat-stroked-button
            [matDialogClose]="{response: 'cancel'}"
            id="dialog-cancel-button">
      {{ 'BUTTON.CANCEL' | translate }}
    </button>
    <button mat-raised-button
            [disabled]="!selectedAssets.length"
            [matDialogClose]="{response: 'yes', selectedAssets: selectedAssets}"
            color="accent"
            id="dialog-confirm-button">
      {{ 'BUTTON.ADD' | translate }}
    </button>
  </mat-dialog-actions>
</div>
